import React, { useContext, useEffect, useState } from 'react';
import { navigate } from '@reach/router';

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'

import AuthContext from '../../services/firebase/AuthContext';
import ClientOrganizationsGrid from './ClientOrganizationsGrid';
import FireDataContext from '../../services/firebase/FireDataContext';
import Grid from '@material-ui/core/Grid'
import appPaths from '../../appPaths';
import AlphabetChooser from './AlphabetChooser';
import Spacer from '../../app/common/ui/Spacer';

const ClientOrganizationsContent = () => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const [user, setUser] = useState(undefined);
    const [filter, setFilter] = useState();
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {

        const fetch = async () => {
            const userData = await db.get({ path: `users/${currentUser.uid}` });
            setUser(userData);

            if (userData?.roles?.includes('admin')) {
                const data = await db.get({
                    path: 'organizations',
                    query: {
                        field: 'adminOrganization',
                        operator: '==',
                        value: userData.organization
                    }
                });

                if (data) {
                    setOrganizations(
                        data.filter(org => org.type === 'cais-client')
                            .sort((a, b) => a.name?.localeCompare(b.name))
                            .map(o => {
                                return {
                                    ...o,
                                    address: o.address ? `${o.address.lines.filter(l => l).join(', ')}, ${o.address.postcode}` : '???',
                                    jurisdiction: !o.defaultTariff ? '???' : o.defaultTariff === 'tier1' ? 'family' : o.defaultTariff
                                }
                            })
                    );
                }
            }
        }

        fetch();

    }, [db, currentUser.uid]);

    if (!user) {
        return <LinearProgress style={{ width: '100%' }} />;
    }

    if (!user.roles?.includes('admin')) {
        return <Alert variant="filled" severity="warning">Sorry - you need to be an administrator to use this page</Alert>;
    }

    const addNewBody = () => {
        navigate(appPaths.admin.newOrganization);
    }

    return (
        <Paper style={{ height: '1000px', width: '100%', padding: '1rem' }}>
            <Grid container spacing={2} style={{ marginBottom: '1rem' }}>
                <Grid item>
                    <Typography variant="h5" color="textSecondary">Referrers (AKA Commissioning Bodies)</Typography>
                </Grid>
                <Grid item>
                    <Button variant="contained" color="secondary" onClick={() => navigate('/admin/sra/referrers')}>Add a solicitor</Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" color="secondary" onClick={addNewBody}>Add an alternative referrer</Button>
                </Grid>
            </Grid>
            <AlphabetChooser onClick={letter => setFilter(new RegExp(`^${letter}`, 'i'))} />
            <Spacer />
            <ClientOrganizationsGrid rows={organizations.filter(o => !filter || filter.test(o.name))} pageSize={30}/>
        </Paper>
    );
}

export default ClientOrganizationsContent;